if (!customElements.get("featured-ingredients")) {
  customElements.define(
    "featured-ingredients",
    class ProductFeaturedIngredients extends HTMLElement {
      constructor() {
        super();
        this.initIngredients();
      }

      initIngredients() {
        const self = this;
        let count = 0;
        const featuredIngredients = self;
        const featuredIngredientsList = featuredIngredients.querySelector("ul");
        const featuredIngredientsListItem = featuredIngredientsList.querySelectorAll("li");
        if (featuredIngredientsList) {
          count = featuredIngredientsListItem.length;
        }

        featuredIngredientsList.style.width = count * 255 + 250;
        var selectedIngredientIndex = Math.min(2, count);
        var selectedIngredient = self.querySelector(
          "li:nth-child(" + selectedIngredientIndex + ")"
        );

        self.scrollIngredient(selectedIngredient);

        featuredIngredientsListItem.forEach((item) => {
          item.addEventListener("click", function (e) {
            self.scrollIngredient(item);
          });
          item.addEventListener("keypress", function (event) {
            if (event.key === "Enter") {
              event.preventDefault(); // Prevents form submission if inside a form
              item.click();
            }
          });
        });

        // Set only for a single element within the ul li of the ingredients section
        if (count === 1) {
          featuredIngredients.classList.add("single");
          featuredIngredientsList.style.width = "100%";
        }
      }

      scrollIngredient(el) {
        const featuredIngredients = el.closest(".featured-ingredients");
        if (!featuredIngredients) {
          return;
        }
        featuredIngredients
          .querySelector(".selected")
          .classList.remove("selected");
        el.classList.add("selected");

        const panelWidth = featuredIngredients.offsetWidth;
        const elComputedStyle = getComputedStyle(el);
        const width =
          el.offsetWidth +
          parseFloat(elComputedStyle.marginLeft) +
          parseFloat(elComputedStyle.marginRight);
        const elPosition =
          el.getBoundingClientRect().left -
          featuredIngredients.querySelector("ul").getBoundingClientRect().left;
        const left = Math.max(
          0,
          Math.round(elPosition + width / 2 - panelWidth / 2)
        );

        featuredIngredients.scrollTo({
          left: left,
          behavior: "smooth",
        });

        const imageContainer =
          this.closest(".ingredients").querySelector(".image-container");
        if (!featuredIngredients) {
          return;
        }
        imageContainer.replaceChildren(el.querySelector("img").cloneNode());
      }
    }
  );
}
